// extracted by mini-css-extract-plugin
export default {"TextWithIcon":"TextWithIcon_TextWithIcon","icon":"TextWithIcon_icon","text":"TextWithIcon_text"};